import { FunctionComponent } from "react";
import styles from "./Checkbox.module.scss";
import { Checkbox } from "@rmwc/checkbox";
import "@rmwc/checkbox/styles";

type ownProps = {
  label?: string;
  checked: boolean;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
};

const CheckboxComponent: FunctionComponent<ownProps> = (props: ownProps) => {
  const { label, checked } = props;
  return (
    <div className={styles.CheckboxComponent}>
      <Checkbox
        label={label}
        checked={checked}
        onChange={(evt) => props.onChange && props.onChange(evt)}
      />
    </div>
  );
};

export { CheckboxComponent, CheckboxComponent as default };
